import { useLocale } from './useLocale';

export function useNumberFormat() {
  const { locale, isDE } = useLocale();

  const formatCurrency = (
    value?: string | number,
    options?: { fractionDigits?: number },
  ): string => {
    if (!value && value !== 0) {
      return '';
    }

    const hasPennies = !Number.isInteger(Number(value));
    const fractionDigits = options?.fractionDigits ?? (hasPennies ? 2 : 0);
    const currencyCode = isDE ? 'EUR' : 'GBP';
    const currencyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });

    return currencyFormatter.format(Number(value));
  };

  const formatPercentage = (value?: string | number): string => {
    if (!value && value !== 0) {
      return '';
    }

    const percentageFormatter = new Intl.NumberFormat(locale, {
      style: 'percent',
      maximumFractionDigits: 2,
    });

    return percentageFormatter.format(Number(value));
  };

  return {
    formatCurrency,
    formatPercentage,
  };
}
